<div class="container">
    <div class="row mb-4" style="color: #222;">
        <div class="col-12">
            <article class="sheet" role="document" aria-label="Target Details">
                <!-- HEADER -->
                <header class="sheet-header">
                    <div class="title">
                        <h1>{{ target().TargetName }}</h1>
                        <small class="muted">Target instructions &amp; details</small>
                    </div>
                    <div class="d-flex align-items-center gap-2 justify-content-end">
                        @if (showGraph()) {
                            <button pButton class="p-button-outlined side-menu-button2" 
                                    icon="pi pi-arrow-left" (click)="onHideGraph()"
                                    [style]="{ border: '1px solid currentColor' }">
                                &nbsp;See Instructions
                            </button>
                        } @else {
                            <button pButton class="p-button-outlined side-menu-button2" 
                                    icon="pi pi-chart-line" (click)="onSeeGraphs()"
                                    [style]="{ border: '1px solid currentColor' }">
                                &nbsp;See Graphs
                            </button>
                        }
                    </div>
                </header>

                <!-- Show Graphs -->
                @if (showGraph()) {
                    <section class="section">
                        <div class="panel bg-blue">
                            <h3 class="pillhead bg-blue-2">Target Graph</h3>
                            <app-target-graph 
                                [patientID]="target().PatientID?.toString()!" 
                                [selectedTargets]="[target()]">
                            </app-target-graph>
                        </div>
                    </section>
                } @else {
                    <!-- Target Instructions -->
                    <section class="section">
                        <div class="panel bg-blue">
                            <h3 class="pillhead bg-blue-2">Target Instructions</h3>
                            <div class="ck ck-content bg-white text-black p-5 instructions-content" 
                                 [innerHTML]="sanitizer.bypassSecurityTrustHtml(target().Instructions ?? '')">
                            </div>
                        </div>
                    </section>

                    <!-- BSP Current Objective -->
                    @if (target().BSP_SkillAcquisitionGoalID || target().SkillAcquisitionGoal_Other) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">BSP Current Objective</h3>
                                <p class="d-block wrap-text">{{ target().BSP_SkillAcquisitionGoalName ?? target().SkillAcquisitionGoal_Other }}</p>
                            </div>
                        </section>
                    }

                    <!-- Treatment Goals -->
                    @if (target().BSP_SkillAcquisitionGoalID && target().TreatmentGoals && (target().TreatmentGoals?.length ?? 0) > 0) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">Treatment Goals that support this objective</h3>
                                @for (goal of target().TreatmentGoals; track goal) {
                                    <div class="ms-3 d-flex align-items-center gap-2 mb-2">
                                        <div class="d-block wrap-text">- {{ goal }}</div>
                                    </div>
                                }
                            </div>
                        </section>
                    }

                    <!-- Attachments -->
                    @if (!isOfflineMode() && attachmentList().length > 0) {
                        <section class="section">
                            <div class="panel bg-blue">
                                <h3 class="pillhead bg-blue-2">Attachments</h3>
                                <div class="att-list-container background-set-white border-small-rounded mt-3">
                                    @for (att of attachmentList(); track att.ID) {
                                        <div class="att-box" role="button" (click)="openAttachmentView(att)">
                                            @if (att.IsImage) {
                                                <img class="m-2" [src]="getImageUrl(att)" 
                                                     style="min-width: 40px; min-height: 40px; max-width: 40px; max-height: 40px;">
                                            } @else {
                                                <i class="m-0 p-0 pi pi-file-o" style="font-size: 25px; color: black;"></i>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </section>
                    }

                    <!-- Target Notes -->
                    <section class="section">
                        <div class="panel bg-blue">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h3 class="pillhead bg-blue-2">Target Notes</h3>
                                @if (!isPreview()) {
                                    <div class="d-flex gap-2">
                                        @if (!isEditingTargetNotes()) {
                                            <button pButton class="p-button-outlined side-menu-button2" 
                                                    icon="pi pi-pencil" (click)="startEditingTargetNotes()">
                                                &nbsp;Edit
                                            </button>
                                        } @else {
                                            <button pButton class="p-button-outlined side-menu-button2"
                                                    icon="pi pi-check" (click)="saveTargetNotes()">
                                                &nbsp;Save
                                            </button>
                                            <button pButton class="p-button-outlined switch-mode-button"
                                                    icon="pi pi-times" (click)="cancelEditingTargetNotes()">
                                                &nbsp;Cancel
                                            </button>
                                        }
                                    </div>
                                }
                            </div>
                            <div class="small text-muted mb-2" *ngIf="target().NotesLastModifiedByUserFullName && target().NotesLastModifiedDate">
                                {{ lastModifiedByText() }}{{ target().NotesLastModifiedDate | date:'MM/dd/yyyy hh:mm a' }}
                            </div>
                            @if (isEditingTargetNotes()) {
                                <textarea
                                    pTextarea
                                    [(ngModel)]="editedTargetNotes"
                                    rows="3"
                                    style="width: 100%; margin-top: 0.5rem"
                                ></textarea>
                            } @else {
                                <div class="p-3 bg-white text-black border rounded" style="min-height: 60px;">
                                    {{ target().TargetNotes || 'No notes available' }}
                                </div>
                            }
                        </div>
                    </section>
                }
            </article>
        </div>
    </div>
</div>

<!-- Attachment View -->
<app-attachment-view
    [doShowAttachmentView]="doShowAttachmentView()"
    [attachment]="selectedAttachment()"
    [canDelete]="false"  
    [view]="'patientInstructionAttachment'"
    (close)="closeAttachmentView()"
></app-attachment-view>

